/**
 * Utility to get Firebase token for API testing
 * 
 * Usage in browser console:
 * 1. Open browser console (F12)
 * 2. Call: getFirebaseToken()
 * 3. Token will be logged and copied to clipboard
 */

import { auth } from '../config/firebase';

export async function getFirebaseToken(): Promise<string | null> {
  try {
    const user = auth.currentUser;
    if (!user) {
      console.error('❌ No user logged in. Please log in first.');
      return null;
    }
    
    const token = await user.getIdToken();
    
    // Copy to clipboard if available
    if (navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(token);
        if (process.env.NODE_ENV === 'development') {
          console.log('Token copied to clipboard');
        }
      } catch (err) {
        // Silent fail
      }
    }
    
    return token;
  } catch (error) {
    console.error('❌ Error getting Firebase token:', error);
    return null;
  }
}

// Make it available globally for easy console access
if (typeof window !== 'undefined') {
  (window as any).getFirebaseToken = getFirebaseToken;
  
  // Also add a simpler alias
  (window as any).getToken = getFirebaseToken;
  
  // Token utility available in console (development only)
}

